import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";

import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link, useLocation } from "react-router-dom";
import CardTool from "../Card/CardTools";
import CardService from "../Card/CardService";
import { useWindowsSize, MoneyFormat, upperCase } from "../../libs";
import Loading from "../Main/Loading";
import ErrorPage from "../../components/Notification/Error";
import { Popover } from "antd";

import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinShareButton,
  LinkedinIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";

function ProductDetail({ props }) {
  const {
    loading,
    layanan,
    data,
    parameter,
    onTab,
    tab,
    onCart,
    qty,
    onQty,
    onSelect,
    loadCart,
    isError,
    onModal,
  } = props;

  const size = useWindowsSize();
  const location = useLocation();
  const link = window?.location?.href ?? "";

  const [isProduct, setIsProduct] = useState(false);

  useEffect(() => {
    if (location) {
      if (location.pathname.includes("product")) {
        setIsProduct(true);
      } else {
        setIsProduct(false);
      }
    }
  }, [location]);

  const content = (
    <div className="flex items-center">
      <FacebookShareButton url={link} className="mx-1 my-2">
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <LinkedinShareButton url={link} className="mx-1 my-2">
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>
      <TelegramShareButton url={link} className="mx-1 my-2">
        <TelegramIcon size={32} round />
      </TelegramShareButton>
      <TwitterShareButton url={link} className="mx-1 my-2">
        <TwitterIcon size={32} round />
      </TwitterShareButton>
      <WhatsappShareButton url={link} className="mx-1 my-2">
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>
    </div>
  );

  return (
    <div className="product">
      <div className="container mx-auto py-6 lg:py-10">
        {/* Breadcrumb */}
        <div name="breadecrumb" className="flex items-center mb-6 lg:mb-8">
          <p className="m-0  text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
            Katalog
          </p>
          <img
            className="mr-3 lg:mr-5"
            src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_arrow.svg"}
            alt="icon-arrow"
          />
          <p className="m-0  text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
            Produk
          </p>
          <img
            className="mr-3 lg:mr-5"
            src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_arrow.svg"}
            alt="icon-arrow"
          />
          <p className="m-0  text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-blue">
            {isProduct ? "Layanan Kesehatan" : "Media Reagensia"}
          </p>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 grid-rows-1 gap-2 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="product-card  p-3 lg:py-10 lg:px-20">
              <div name="header-section" className="flex items-center">
                <div
                  className="w-24 h-24 lg:w-40 lg:h-36 mr-4 lg:mr-6"
                  onClick={onModal}
                >
                  <img
                    className="w-24 h-24 lg:w-40 lg:h-36 object-cover rounded-2xl cursor-pointer"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/assets/image/img_empty.png"; // some replacement image
                    }}
                    src={
                      typeof data.image !== "string"
                        ? process.env.REACT_APP_BACKEND_URL +
                          "/storage/" +
                          data.image[0]
                        : process.env.REACT_APP_BACKEND_URL +
                          "/storage/" +
                          data.image
                    }
                    alt="img-media"
                  />
                </div>
                <div className="w-3/4">
                  <p className="m-0 header-content text-xs lg:text-base colors-gray">
                    {isProduct ? "Layanan Kesehatan" : "Media reagensia"}
                  </p>
                  <p className="m-0 header-title-bold colors-blue text-base lg:text-xl colors-blue font-bold">
                    {upperCase(
                      data?.name ??
                        "PCR Swab Test (Drive Thru) - Hasil 1 Hari Kerja"
                    )}
                  </p>
                  <div className="flex items-center mt-1 mb-1 lg:mb-3">
                    <p className="m-0 header-content  colors-gray mr-3 lg:mr-5 text-xs">
                      {data?.sold ?? "0"} terjual
                    </p>
                    {/* <div className="flex items-center ">
                      <img
                        className="mr-1"
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/ic_star.svg"
                        }
                        alt="icon-star"
                      />
                      <span className="colors-gray text-xs">5</span>
                      <span className="ml-2 colors-gray text-xs">
                        (49 Ulasan)
                      </span>
                    </div> */}
                  </div>
                  <div
                    className={`flex items-center ${
                      size.width > 640 ? "" : "justify-between"
                    }`}
                  >
                    <p className="m-0 header-title-semi lg:mr-10 colors-orange font-bold mt-2 text-base lg:text-xl">
                      {data.price
                        ? "Rp. " + MoneyFormat(Number(data.price))
                        : "Rp. 100.000"}
                    </p>
                    {isProduct ? null : (
                      <div
                        className={`rounded p-1 mt-1 ${
                          data.status_no === 1
                            ? "colors-green-young"
                            : data.status_no === 3
                            ? "colors-yellow-young"
                            : "colors-red-young"
                        }`}
                      >
                        <p
                          className={`m-0 font-semibold text-xs ${
                            data.status_no === 1
                              ? "text-green-800"
                              : data.status_no === 3
                              ? "text-yellow-800"
                              : "text-red-800"
                          }`}
                        >
                          {data.status_no === 1
                            ? data.status_text
                            : data.status_no === 3
                            ? data.status_text
                            : data.status_text}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Foto Lainnya Section */}
              {typeof data.image !== "string" && (
                <div name="+10 image" className="flex items-center">
                  {data.image.slice([0], [3]).map((it, idx) => (
                    <div
                      key={idx}
                      onClick={onModal}
                      className="w-12 h-12 mr-2 my-5 bg-gray-100 rounded-xl "
                    >
                      <img
                        className="w-12 h-12 object-cover rounded-xl cursor-pointer"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/assets/image/img_empty.png"; // some replacement image
                        }}
                        src={
                          process.env.REACT_APP_BACKEND_URL + "/storage/" + it
                        }
                        alt="img-media"
                      />
                    </div>
                  ))}

                  {data.image.length > 3 && (
                    <div className="ml-2 cursor-pointer" onClick={onModal}>
                      <p className="m-0 colors-blue font-bold text-xs">
                        +{data.image.length - 3}
                      </p>
                      <p className="m-0 header-content  text-xs colors-gray">
                        Foto Lainnya
                      </p>
                    </div>
                  )}
                </div>
              )}
              <div name="menu-section" className="mt-3">
                <div
                  className={`home-switch ${
                    data.detail_paket.length > 0 ? "w-52" : "w-24"
                  } px-1 py-2 flex justify-around items-center`}
                >
                  <div
                    onClick={() => onTab("1")}
                    className={`${
                      tab === "1"
                        ? "home-switch-active py-1 px-2 font-semibold"
                        : ""
                    } cursor-pointer colors-blue `}
                  >
                    Deskripsi
                  </div>
                  {data.detail_paket.length > 0 && (
                    <div
                      onClick={() => onTab("2")}
                      className={`${
                        tab === "2"
                          ? "home-switch-active py-1 px-2 font-semibold"
                          : ""
                      }   cursor-pointer colors-blue`}
                    >
                      Detail Paket
                    </div>
                  )}
                  {/* <div
                    onClick={() => onTab("3")}
                    className={`${
                      tab === "3"
                        ? "home-switch-active py-1 px-2 font-semibold"
                        : ""
                    }  cursor-pointer colors-blue`}
                  >
                    Ulasan
                  </div> */}
                </div>
              </div>
              <div className="mt-4 lg:mt-6">
                {tab === "1" ? (
                  <>
                    <p className="header-content colors-gray">
                      {data?.description ?? "Ini adalah deskripsi item"}
                    </p>
                    <div className="mt-5">
                      <div className="flex items-center ">
                        <div className="mr-3 lg:mr-4 ">
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              "/assets/icon/ic_info_blue.svg"
                            }
                            alt="icon-info-blue"
                            className="w-5 lg:w-4"
                          />
                        </div>
                        <p className="colors-blue text-xs lg:text-base header-title-semi">
                          Informasi Waktu Pelayanan
                        </p>
                      </div>
                      <p>
                        • Layanan Kesehatan Maksimal Sampai Jam <b>17:00 WIB</b>
                      </p>
                      <p>
                        • Layanan Kesehatan Tes Covid Maksimal Sampai Jam{" "}
                        <b>12:00 WIB</b>
                      </p>
                    </div>
                  </>
                ) : tab === "2" && data.detail_paket.length > 0 ? (
                  data.detail_paket.map((it, idx) => (
                    <p key={idx} className="header-content colors-gray my-1">
                      ‣ {upperCase(it.parameter.name)}
                    </p>
                  ))
                ) : (
                  <p className="colors-gray">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                  </p>
                )}
              </div>
            </div>
          </div>
          {size.width > 640 && (
            <div className="product-card p-10">
              <div name="header-section w-full mt-2">
                <p className="text-center colors-blue font-semibold text-2xl">
                  {isProduct
                    ? "Pilih tanggal dan waktu kunjungan"
                    : "Atur Jumlah dan Catatan"}
                </p>
              </div>
              {!isProduct && (
                <>
                  <div
                    name="qty-section"
                    className="flex justify-center items-center mt-6"
                  >
                    <img
                      onClick={() => (qty <= 1 ? null : onQty("min"))}
                      className="cursor-pointer"
                      src={
                        process.env.REACT_APP_BASE_URL +
                        `/assets/icon/${
                          qty <= 1 ? "ic_min.svg" : "ic_min_blue.svg"
                        }`
                      }
                      alt="icon-minus"
                    />
                    <p className="colors-blue font-semibold m-0 text-xl mx-3">
                      {qty}
                    </p>
                    <img
                      onClick={() => (qty >= data.qty ? null : onQty("plus"))}
                      className="cursor-pointer"
                      src={
                        process.env.REACT_APP_BASE_URL +
                        `/assets/icon/${
                          qty >= data.qty ? "ic_plus_gray.svg" : "ic_plus.svg"
                        }`
                      }
                      alt="icon-plus"
                    />
                    <div className="colors-gray ml-4">Stok {data.qty}</div>
                  </div>
                  <div
                    className={`text-center mt-2  text-xs ${
                      qty >= data.qty ? "text-red-500" : "colors-gray"
                    }`}
                  >
                    {data.qty !== 0
                      ? `Max. pembelian ${data.qty} pcs`
                      : "Stok Habis"}
                  </div>
                </>
              )}
              <div name="form-input mt-8">
                {isProduct ? null : (
                  <div name="catatan-form" className="mt-10">
                    <p className="login-title-form mb-1 text-lg">Catatan</p>
                    <input
                      name="note"
                      onChange={onSelect}
                      className="form-input outline-none w-full p-3"
                      placeholder="Catatan bila ada"
                    />

                    {isError
                      ? isError.length > 0
                        ? isError
                            .filter((it) => it.type === "note")
                            .map((its, idx) => (
                              <ErrorPage
                                key={idx}
                                props={{ idx, message: its.message }}
                              />
                            ))
                        : null
                      : null}
                  </div>
                )}

                {isProduct && (
                  <div
                    name="tanggal-form"
                    className={isProduct ? "mt-10" : "mt-5"}
                  >
                    <p className="login-title-form mb-1 text-lg">
                      {isProduct ? "Tanggal Kunjungan" : "Tanggal Pengambilan"}
                    </p>
                    <input
                      name="tgl_pemeriksaan"
                      onChange={onSelect}
                      type="date"
                      className="form-input outline-none w-full p-3"
                      placeholder={`Pilih tanggal ${
                        isProduct ? "kunjungan" : "pengambilan"
                      } `}
                    />

                    {isError
                      ? isError.length > 0
                        ? isError
                            .filter((it) => it.type === "date")
                            .map((its, idx) => (
                              <ErrorPage
                                key={idx}
                                props={{ idx, message: its.message }}
                              />
                            ))
                        : null
                      : null}
                  </div>
                )}
                {isProduct ? (
                  <div name="time-form" className="mt-5">
                    <p className="login-title-form mb-1 text-lg ">
                      {isProduct ? "Waktu Kunjungan" : "Tanggal Pengambilan"}
                    </p>
                    <input
                      name="jam_pemeriksaan"
                      onChange={onSelect}
                      type="time"
                      className="form-input outline-none w-full p-3"
                      placeholder={`Pilih waktu ${
                        isProduct ? "kunjungan" : "pengambilan"
                      } `}
                    />

                    {isError
                      ? isError.length > 0
                        ? isError
                            .filter((it) => it.type === "time")
                            .map((its, idx) => (
                              <ErrorPage
                                key={idx}
                                props={{ idx, message: its.message }}
                              />
                            ))
                        : null
                      : null}
                  </div>
                ) : null}
              </div>
              <div
                name="total-section"
                className="flex justify-between mt-8 items-center"
              >
                <p className="colors-blue font-semibold header-content">
                  Total
                </p>
                <p className="colors-orange font-semibold text-xl">
                  {data.price
                    ? "Rp. " + MoneyFormat(Number(data.price * qty))
                    : "Rp. 100.000"}
                </p>
              </div>
              <div className="w-full mt-8">
                <button
                  disabled={
                    loadCart ||
                    data.status === 2 ||
                    (data.qty === 0 && !isProduct)
                  }
                  onClick={() => (isProduct ? onCart(1, 1) : onCart(qty, 1))}
                  className={`${
                    loadCart ||
                    data.status === 2 ||
                    (data.qty === 0 && !isProduct)
                      ? "btn-loading"
                      : "btn-blue"
                  } w-full p-3  focus:outline-none`}
                >
                  <p className="text-white lg:text-lg ">
                    {loadCart
                      ? "Loading"
                      : data.status === 2
                      ? "Not Ready"
                      : data.status === 3
                      ? "Pre Order"
                      : data.qty === 0 && !isProduct
                      ? "Stok Habis"
                      : isProduct
                      ? "Buat Janji"
                      : "Beli Sekarang"}
                  </p>
                </button>
                {(data.status === 2 || data.qty !== 0) && (
                  <button
                    disabled={
                      loadCart ||
                      data.status === 2 ||
                      (data.qty === 0 && !isProduct)
                    }
                    onClick={() => (isProduct ? onCart(1, 2) : onCart(qty, 2))}
                    className={`${
                      loadCart ||
                      data.status === 2 ||
                      (data.qty === 0 && !isProduct)
                        ? "btn-loading"
                        : "btn-white"
                    } w-full p-3 mt-4 focus:outline-none`}
                  >
                    <p className="colors-gray lg:text-lg">
                      {loadCart
                        ? "Loading"
                        : data.status === 2
                        ? "Not Ready"
                        : data.status === 3
                        ? "Pre Order"
                        : data.qty === 0 && !isProduct
                        ? "Stok Habis"
                        : isProduct
                        ? "Tambahkan ke pesanan"
                        : "Tambahkan ke pesanan"}
                    </p>
                  </button>
                )}
              </div>
              <div
                name="footer-section "
                className="flex justify-center items-center mt-10"
              >
                {/* <div className="flex items-center cursor-pointer">
                  <img
                    className="mr-3"
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/icon/ic_chat.svg"
                    }
                    alt="icon-chat"
                  />
                  <p className="colors-gray font-semibold text-sm">
                    Chat Penjual
                  </p>
                </div>
                <div>|</div> */}

                <Popover
                  placement="bottom"
                  title={null}
                  content={content}
                  trigger="click"
                >
                  <div className="flex items-center cursor-pointer">
                    <img
                      className="mr-3"
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/ic_share.svg"
                      }
                      alt="icon-share"
                    />
                    <p className="colors-gray font-semibold text-sm header-content">
                      Bagikan
                    </p>
                  </div>
                </Popover>
              </div>
            </div>
          )}
        </div>
        {!isProduct ? (
          <div>
            <p className="colors-blue mt-8 lg:mt-0 text-xl lg:text-2xl font-bold">
              Produk Lainnya
            </p>
            <div className="w-full mt-5">
              <Swiper
                spaceBetween={
                  size.width > 1280
                    ? 60
                    : size.width > 1024
                    ? 40
                    : size.width >= 768
                    ? 20
                    : 10
                }
                slidesPerView={
                  size.width >= 1280
                    ? 5
                    : size.width >= 1024
                    ? 4
                    : size.width >= 768
                    ? 3
                    : 2
                }
              >
                {layanan.map((it, index) => (
                  <SwiperSlide key={index}>
                    <Link key={index} to={`/media/${it.id}`}>
                      <CardTool props={{ media: it }} />
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        ) : (
          <div>
            <p className="header-title-bold colors-blue mt-8 lg:mt-0 text-xl lg:text-2xl font-bold">
              Layanan Lainnya
            </p>
            {loading ? (
              <Loading />
            ) : (
              <div className="w-full mt-5">
                <Swiper spaceBetween={30} slidesPerView={2}>
                  {layanan.map((it, index) => (
                    <SwiperSlide key={index}>
                      <Link
                        key={index}
                        to={
                          parameter === "paket"
                            ? `/product/paket/${it.id}`
                            : parameter === "satuan"
                            ? `/product/satuan/${it.id}`
                            : null
                        }
                      >
                        <CardService props={{ layanan: it }} />
                      </Link>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Ini Footer Buat Checkout */}
      {size.width <= 640 && (
        <div
          className="product-checkout bg-white px-5 h-20"
          style={{ zIndex: 1 }}
        >
          <div className="flex justify-between items-center content-center h-full">
            {/* <div>
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "/assets/icon/ic_chat.svg"
                }
                alt="icon-chat"
              />
            </div> */}
            <div className="w-1/3">
              <Popover
                placement="rightBottom"
                title={null}
                content={content}
                trigger="click"
              >
                <img
                  src={
                    process.env.REACT_APP_BASE_URL + "/assets/icon/ic_share.svg"
                  }
                  alt="icon-share"
                />
              </Popover>
            </div>
            <div className="flex justify-end items-center content-center  w-2/3">
              {loadCart ||
              data.status === 2 ||
              (data.qty === 0 && !isProduct) ? null : (
                <div
                  disabled={
                    loadCart ||
                    data.status === 2 ||
                    (data.qty === 0 && !isProduct)
                  }
                  onClick={() =>
                    loadCart ||
                    data.status === 2 ||
                    (data.qty === 0 && !isProduct)
                      ? null
                      : isProduct
                      ? onCart(1, 2)
                      : onCart(qty, 2)
                  }
                  className="product-cart py-3 px-4 mr-3"
                >
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/icon/ic_cart_gray.svg"
                    }
                    alt="icon-cart"
                  />
                </div>
              )}{" "}
              <div className="w-2/3">
                <button
                  disabled={
                    loadCart ||
                    data.status === 2 ||
                    (data.qty === 0 && !isProduct)
                  }
                  onClick={() => (isProduct ? onCart(1, 1) : onCart(qty, 1))}
                  className={`${
                    loadCart ||
                    data.status === 2 ||
                    (data.qty === 0 && !isProduct)
                      ? "btn-loading"
                      : "btn-blue"
                  } w-full p-3 focus:outline-none`}
                >
                  <p className="text-white lg:text-lg ">
                    {loadCart
                      ? "Loading"
                      : data.status === 2
                      ? "Not Ready"
                      : data.status === 3
                      ? "Pre Order"
                      : data.qty === 0 && !isProduct
                      ? "Stok Habis"
                      : isProduct
                      ? "Buat Janji"
                      : "Beli Sekarang"}
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductDetail;
